// extracted by mini-css-extract-plugin
export default {"desktopSidebar":"root_navbar-island-module__desktopSidebar___W4__v","mobileSidebarHeader":"root_navbar-island-module__mobileSidebarHeader___b7LWJ"};